import React, { useEffect } from 'react';
import M from 'materialize-css';

function CustomInput(props) {
  const { id, label, value, setValue, hide } = props;

  useEffect(() => {
    M.AutoInit();
  }, []);

  if (hide) {
    return <div />;
  }

  return (
    <div className="input-field col s12">
      <input id={id} type="text" className="validate" value={value || ''} onChange={(e) => setValue(e.target.value)} />
      <label htmlFor="name" className="active">
        {label}
      </label>
    </div>
  );
}

export default CustomInput;
